<template>
  <div class="d-flex align-center">
    <div class="d-flex flex-column align-end mr-2">
      <div class="font-weight-bold">
        {{ title }}
      </div>
      <div class="text-caption rounded-pill px-2" style="font-size: 0.65rem !important" :style="{ 'background-color': pillColor ?? '#545253'}">
        {{ subtitle }}
      </div>
    </div>
    <v-avatar
      v-if="imageSrc"
      color="white"
      class="mr-2 pa-1"
      size="50"
    >
      <v-img
        :src="imageSrc"
        contain
      />
    </v-avatar>
    <v-avatar
      v-else
      color="white"
      class="mr-2"
      size="50"
    >
      <v-icon color="#363636" icon="fa-regular fa-user-headset" size="27" />
    </v-avatar>
  </div>
</template>

<script lang="ts" setup>

interface Props {
  title: string
  subtitle: string
  imageSrc?: string
  pillColor?: string
}

const { title, subtitle, imageSrc } = defineProps<Props>()

</script>
